<template>
  <div>
    <v-text-field
      v-model.number="anio"
      type="number"
      label="Selecciona el año"
      outlined
    ></v-text-field>

    <v-select
      v-model="tramiteId"
      :items="[
        { text: 'Permisos de circulación Vehiculos Livianos', value: 3 },
        { text: 'Permisos de circulación Vehiculos Pesados', value: 5 },
        { text: 'Permisos de circulación Locomoción Colectiva', value: 6 },
      ]"
      dense
      label="Tramite"
      outlined
    />


    <v-card max-width="600px" class="my-4 mx-auto">
      <v-card-title> Cantidad Segundas Cuotas</v-card-title>
      <v-card-text>
        <v-btn
          color="primary"
          @click="consultarCuotas"
          :loading="loadingConsulta"
        >
          Consultar Segundas Cuotas
        </v-btn>
        <div v-if="respuestaConsulta!== null" class="mt-4">
          <p>Cantidad de segundas cuotas por generar: {{ respuestaConsulta.cantidad }}</p>
        </div>
      </v-card-text>
    </v-card>

    <v-card max-width="600px" class="my-4 mx-auto">
      <v-card-title> Pago Unico </v-card-title>
      <v-text-field
        v-model.number="cuentaIdPagoUnico"
        type="number"
        label="Ingrese ID de Cuenta"
        class="mx-4"
        outlined
      ></v-text-field>
      <v-card-text>
        <v-btn
          color="primary"
          @click="generarPagoUnico"
          :loading="loadingPagoUnico"
          :disabled="!cuentaIdPagoUnico"
        >
          Generar Pago Unico
        </v-btn>
        <div v-if="respuestaPagoUnico!== null" class="mt-4">
          <p>{{ respuestaPagoUnico.mensaje }}</p>
        </div>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
export default {
  data() {
    return {
      anio: new Date().getFullYear(),
      tramiteId: 3,
      loadingConsulta: false,
      loadingPagoUnico: false,
      respuestaConsulta: null,
      respuestaPagoUnico: null,
      cuentaIdPagoUnico: null,
    };
  },
  methods: {
    async consultarCuotas() {
      this.loadingConsulta = true;
      try {
        const url = 'permisosdecirculacion/segundas_cuotas_faltantes?anio=' + this.anio + '&tramiteId=' + this.tramiteId;
        const response = await this.$axios.get(url);
        this.respuestaConsulta = response.data;
      } catch (error) {
        console.error('Error al consultar cuotas:', error);
      } finally {
        this.loadingConsulta = false;
      }
    },
    async generarPagoUnico() {
      if (!this.cuentaIdPagoUnico) {
        return;
      }
      this.loadingPagoUnico = true;
      try {
        const response = await this.$axios.post('permisosdecirculacion/segundas_cuotas_faltantes', {
          cuentaId: this.cuentaIdPagoUnico,
        });
        this.respuestaPagoUnico = response.data;
      } catch (error) {
        console.error('Error al generar pago único:', error);
      } finally {
        this.loadingPagoUnico = false;
      }
    },
  }
}
</script>
